<template>
  <div>
    <div v-if="!isTablet" class="teacher-list-items" :class="maxHeight">
      <div class="flex space-x-1 w-2/3">
        <div class="w-[18%]">
          <TeacherListItemsAvatar :size="{lg: '128', xs: '76'}" />
        </div>
        <div class="w-[50%] p-4 pt-0">
          <TeacherListItemsName />
          <TeacherListItemsTeachingCourse class="mt-6" />
          <div class="flex items-center space-x-8">
            <TeacherListItemsReview class="mt-1" @click="reviewClicked" />
            <TeacherListItemsLessons class="mt-1" />
          </div>
          <TeacherListItemsLanguage class="mt-1" />
          <TeacherListItemsHighlights
            class="mt-6"
            :show-full="showFull"
            @toggleHeight="toggleHeight"
          />
        </div>
        <div class="w-[32%] flex flex-col space-y-[185px] p-4 pt-0">
          <div class="flex justify-between">
            <TeacherListItemsPrice class="w-4/5" :is-active="priceActive" />
            <BaseTooltipTop
              :text="$t('common.titles.saved')"
              background="bg-white"
            >
              <TeacherListItemsLike class="w-1/5 mt-6" />
            </BaseTooltipTop>
          </div>
          <TeacherListItemsAction
            @mouseLeave="priceActive = false"
            @mouserOver="priceActive = true"
            @bookingClicked="bookingClicked"
          />
        </div>
      </div>
      <div class="w-1/3 p-4 pt-0">
        <TeacherListItemsIntroduction
          :show-full="showFull"
          @toggleHeight="toggleHeight"
        />
      </div>
    </div>
    <div v-else class="teacher-list-items">
      <div class="flex space-x-6 items-start">
        <TeacherListItemsAvatar
          :show-btn="false"
          class="w-4/12"
          :size="{lg: '128', xs: '76'}"
        />
        <div class="w-7/12 overflow-hidden">
          <TeacherListItemsName />
          <TeacherListItemsTeachingCourse class="mt-4" />
          <TeacherListItemsReview
            class="mt-1"
            @click="reviewClicked"
          />
          <TeacherListItemsLessons class="mt-1" />
        </div>
        <TeacherListItemsLike class="w-1/12" />
      </div>
      <div class="mt-4">
        <TeacherListItemsLanguage />
        <TeacherListItemsHighlights
          class="mt-4"
          :show-full="showFull"
          @toggleHeight="toggleHeight"
        />
      </div>
      <div class="mt-4">
        <TeacherListItemsPrice />
        <TeacherListItemsAction
          class="mt-4"
          @bookingClicked="bookingClicked"
        />
      </div>
    </div>
  </div>
</template>
<script>
import detectDeviceMixin from '@helper/detectDeviceMixin'
import BaseTooltipTop from '@design-system/base/tooltip/tooltip-top.vue'
import { _teacher } from './constructor'
import TeacherListItemsAvatar from '@/components/common/teacher-list-items/teacher-list-items-avatar.vue'
import TeacherListItemsName from '@/components/common/teacher-list-items/teacher-list-items-name.vue'
import TeacherListItemsLanguage from '@/components/common/teacher-list-items/teacher-list-items-language.vue'
import TeacherListItemsReview from '@/components/common/teacher-list-items/teacher-list-items-review.vue'
import TeacherListItemsLessons from '@/components/common/teacher-list-items/teacher-list-items-lessons.vue'
import TeacherListItemsHighlights from '@/components/common/teacher-list-items/teacher-list-items-highlights.vue'
import TeacherListItemsPrice from '@/components/common/teacher-list-items/teacher-list-items-price.vue'
import TeacherListItemsLike from '@/components/common/teacher-list-items/teacher-list-items-like.vue'
import TeacherListItemsAction from '@/components/common/teacher-list-items/teacher-list-items-action.vue'
import TeacherListItemsIntroduction from '@/components/common/teacher-list-items/teacher-list-items-introduction.vue'
import TeacherListItemsTeachingCourse from '@/components/common/teacher-list-items/teacher-list-items-teaching-course.vue'

export default {
  name: 'CommonTeacherListItems',
  components: {
    BaseTooltipTop,
    TeacherListItemsTeachingCourse,
    TeacherListItemsIntroduction,
    TeacherListItemsAction,
    TeacherListItemsLike,
    TeacherListItemsPrice,
    TeacherListItemsHighlights,
    TeacherListItemsLessons,
    TeacherListItemsReview,
    TeacherListItemsLanguage,
    TeacherListItemsName,
    TeacherListItemsAvatar,
  },
  mixins: [detectDeviceMixin],
  provide () {
    return { teacher: _teacher(this.teacher) }
  },
  props: {
    teacher: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      showFull: false,
      maxHeight: 'max-h-[405px] overflow-y-hidden',
      priceActive: false
    }
  },
  methods: {
    reviewClicked () {
      this.$emit('reviewClicked', _teacher(this.teacher))
    },
    toggleHeight (val) {
      this.showFull = val
      this.maxHeight = val ? 'max-h-[620px]' : 'max-h-[405px]'
    },
    bookingClicked () {
      this.$emit('bookingClicked', this.teacher.id)
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-list-items {
  @apply border border-primary-100 lg:hover:border-primary-700 rounded-lg p-4 lg:p-6 mb-4 lg:mb-6 flex
  space-x-1 lg:flex-row flex-col lg:divide-x lg:divide-primary-100
  transition-all overflow-y-hidden;
}
.like {
  // padding-top: 20px !important;
  margin-top: 20px;
}
</style>
